import { render, staticRenderFns } from "./SurveyPreview.vue?vue&type=template&id=3bcdc73e&"
import script from "./SurveyPreview.vue?vue&type=script&lang=js&"
export * from "./SurveyPreview.vue?vue&type=script&lang=js&"
import style0 from "./SurveyPreview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports